var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenConsultRecent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19C8 18.4477 8.44772 18 9 18H17.9146C18.1236 18 18.3265 18.0702 18.4909 18.1993C19.1029 18.6802 20 18.2442 20 17.4659V10C20 9.44771 20.4477 9 21 9C21.5523 9 22 9.44772 22 10V21.4425C22 22.277 21.0383 22.7444 20.3822 22.2288L17.8175 20.2137C17.6413 20.0753 17.4237 20 17.1996 20H9C8.44772 20 8 19.5523 8 19ZM5.80041 16C5.57635 16 5.35878 16.0752 5.18259 16.2137L2.61782 18.2289C1.96169 18.7444 1 18.277 1 17.4425V4C1 3.44772 1.44772 3 2 3H17C17.5523 3 18 3.44772 18 4V15C18 15.5523 17.5523 16 17 16H5.80041Z",
    fill: "#12C0B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenConsultRecent);
export default __webpack_public_path__ + "static/media/open-consult-recent.dbcc993c5ecef08b810c2b14391040ea.svg";
export { ForwardRef as ReactComponent };